import moment from 'moment';

export default function getDaysOfWeek() {
  const weekDays = [];
  for (let i = 0; i < 7; i += 1) {
    weekDays.push({ nom: moment().weekday(i).format('ddd'), numero: i, selected: true });
  }
  return weekDays;
}
